// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Vbhe8WsJuQie9CKK0X_V{flex-direction:column;align-items:center;width:100%;min-height:100vh;padding:48px 24px;display:flex}.xbuAX2skltEXyzIZNH9k{flex:none;margin-top:-67px;margin-bottom:-67px}.At5RmrbQGsoRRb5RJPwI{text-align:center;flex-direction:column;flex:auto;justify-content:center;align-items:center;max-width:800px;padding:20px 0;display:flex}.huUlfPXlKP0dVRt2Ol0b{background:var(--light-blue-10);border-radius:50%;justify-content:center;align-items:center;width:80px;height:80px;margin-bottom:24px;display:flex}.SMirVbH2VSwag3IzbQcN{background:var(--light-blue-60);border-radius:12px;justify-content:center;align-items:center;width:32px;height:32px;display:flex}.TW708jcZIVQw2Is6d2sz{margin-bottom:8px}.qohcZyw3zTQP6tyFCaJL{margin-bottom:24px}.QDGgfe1iHcAGw8UlRjr8{align-items:center;gap:8px;display:flex}.XFSgDdR2sgFzeKeJ9q1k{min-width:152px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `Vbhe8WsJuQie9CKK0X_V`,
	"logo": `xbuAX2skltEXyzIZNH9k`,
	"content": `At5RmrbQGsoRRb5RJPwI`,
	"iconCircle": `huUlfPXlKP0dVRt2Ol0b`,
	"iconBox": `SMirVbH2VSwag3IzbQcN`,
	"title": `TW708jcZIVQw2Is6d2sz`,
	"description": `qohcZyw3zTQP6tyFCaJL`,
	"actionsWrap": `QDGgfe1iHcAGw8UlRjr8`,
	"action": `XFSgDdR2sgFzeKeJ9q1k`
};
export default ___CSS_LOADER_EXPORT___;
